import * as React from 'react';
const IconAdd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    style={{ width: 32, height: 32 }}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M16 7C17.1046 7 18 7.89543 18 9V14H23C24.1046 14 25 14.8954 25 16C25 17.1046 24.1046 18 23 18H18V23C18 24.1046 17.1046 25 16 25C14.8954 25 14 24.1046 14 23V18H9C7.89543 18 7 17.1046 7 16C7 14.8954 7.89543 14 9 14H14V9C14 7.89543 14.8954 7 16 7Z"
      fill="#020000"
    />
    <path
      d="M28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
      fill="#020000"
    />
  </svg>
);
export default IconAdd;
